// Generated code; do not edit.
// You might be looking for: packages/bank-schemas/bank.graphql
// To regenerate: yarn workspaces foreach -A run generate-types

import type * as Types from '../../gqltypes';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type DismissPromotionInfoMutationVariables = Types.Exact<{
  fid: Types.Scalars['ID'];
}>;

export type DismissPromotionInfoMutation = {
  readonly __typename: 'Mutation';
  readonly dismissPromotionHint: {
    readonly __typename: 'Promotion';
    readonly fid: string;
    readonly showInfoAboutChanges: boolean;
  };
};

export type OwnPromotionWaitingForApprovalQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type OwnPromotionWaitingForApprovalQuery = {
  readonly __typename: 'Query';
  readonly me: {
    readonly __typename: 'Agent';
    readonly fid: string;
    readonly state: Types.AgentState;
    readonly type: Types.AgentType;
    readonly latestPromotion: {
      readonly __typename: 'Promotion';
      readonly fid: string;
      readonly state: Types.PromotionState;
    } | null;
  };
};

export type OwnPromotionAfterSigningQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type OwnPromotionAfterSigningQuery = {
  readonly __typename: 'Query';
  readonly me: {
    readonly __typename: 'Agent';
    readonly fid: string;
    readonly state: Types.AgentState;
    readonly latestPromotion: {
      readonly __typename: 'Promotion';
      readonly fid: string;
      readonly state: Types.PromotionState;
      readonly signing: {
        readonly __typename: 'SigningJob';
        readonly type: Types.SigningType;
        readonly url: string | null;
      } | null;
    } | null;
  };
};

export const DismissPromotionInfoDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DismissPromotionInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dismissPromotionHint' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'fid' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showInfoAboutChanges' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DismissPromotionInfoMutation,
  DismissPromotionInfoMutationVariables
>;
export const OwnPromotionWaitingForApprovalDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OwnPromotionWaitingForApproval' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'latestPromotion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OwnPromotionWaitingForApprovalQuery,
  OwnPromotionWaitingForApprovalQueryVariables
>;
export const OwnPromotionAfterSigningDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OwnPromotionAfterSigning' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'latestPromotion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'signing' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OwnPromotionAfterSigningQuery,
  OwnPromotionAfterSigningQueryVariables
>;
